// @symbo.ls/collab-features/tickets — governance Supabase tickets
// access for consumers outside the intranet (editor embed, admin
// dashboard, reporting). Tickets live in the governance project.

import { getClient, PROJECT_GOVERNANCE } from '../../../governanceBridge.js'

export const TICKETS_CONFIG = Object.freeze({
  projectName: PROJECT_GOVERNANCE,
  tables: {
    tickets: 'tickets',
    comments: 'ticket_comments',
    columns: 'ticket_columns',
    fieldValues: 'ticket_field_values',
    stories: 'stories'
  }
})

const _sb = () => getClient(TICKETS_CONFIG.projectName)
export const ticketsAvailable = () => !!_sb()

// Assignee-scoped list. RLS post-Phase-3 filters to active workspace;
// `assignee` narrows to one user's queue. `columnKey` optional for
// board lanes.
export const listTickets = async ({ assignee, columnKey, limit = 50 } = {}) => {
  const sb = _sb()
  if (!sb) return { data: [], error: null }
  let q = sb
    .from(TICKETS_CONFIG.tables.tickets)
    .select('*')
    .eq('deleted', false)
    .order('updated_at', { ascending: false })
    .limit(limit)
  if (assignee) q = q.eq('assignee_email', assignee)
  if (columnKey) q = q.eq('column_key', columnKey)
  return q
}

export const getTicket = async (id) => {
  const sb = _sb()
  if (!sb) return { data: null, error: null }
  return sb.from(TICKETS_CONFIG.tables.tickets).select('*').eq('id', id).maybeSingle()
}

export const listColumns = async () => {
  const sb = _sb()
  if (!sb) return { data: [], error: null }
  return sb.from(TICKETS_CONFIG.tables.columns).select('*').order('position', { ascending: true })
}

export const createTicket = async (patch) => {
  const sb = _sb()
  if (!sb) return { data: null, error: new Error('governance unavailable') }
  return sb.from(TICKETS_CONFIG.tables.tickets).insert(patch).select('*').single()
}

export const updateTicket = async (id, patch) => {
  const sb = _sb()
  if (!sb) return { data: null, error: new Error('governance unavailable') }
  return sb
    .from(TICKETS_CONFIG.tables.tickets)
    .update({ ...patch, updated_at: new Date().toISOString() })
    .eq('id', id)
    .select('*')
    .maybeSingle()
}

export const listComments = async (ticketId) => {
  const sb = _sb()
  if (!sb) return { data: [], error: null }
  return sb
    .from(TICKETS_CONFIG.tables.comments)
    .select('*')
    .eq('ticket_id', ticketId)
    .order('created_at', { ascending: true })
}
